export const listPhases = `
   query listPhases($filter: PhasesFilterInput, $limit: Int, $nextToken:  String) {
       listPhases(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              playbookId
              name
              displayName
              description
              position
              createdByUsername
              created
              updated
           }
       }
   }
`;

export const getPhase = `
   query getPhase($id:ID!) {
       getPhase(id:$id) {
         id
         playbookId
         name
         displayName
         description
         position
         createdByUsername
         created
         updated
       }
}`;
